import { PressCard } from "@components/press_card/press_card";
import { PressItemModel } from "@root/types";
import React, { FC } from "react";

interface PressGridProps {
  pressItems: PressItemModel[];
}

const PressGrid: FC<PressGridProps> = ({ pressItems }) => {
  return (
    <div className="press-grid">
      {pressItems.map((pressItem) => (
        <PressCard
          key={pressItem.id}
          classes="press-grid--item"
          pressItem={pressItem}
        />
      ))}
    </div>
  );
};

export { PressGrid, PressGridProps };
